/**
 * Utilitaire pour gérer les cookies d'affiliation
 * Cookie valide pendant 30 jours
 */

const AFFILIATE_COOKIE_NAME = 'fp_affiliate';
const AFFILIATE_NAME_COOKIE = 'fp_affiliate_name';
const AFFILIATE_CODE_COOKIE = 'fp_affiliate_code';
const COOKIE_DURATION_DAYS = 30;

export interface AffiliateCookieData {
  affiliateId: string;
  affiliateName?: string;
  code?: string;
}

/**
 * Définit un cookie avec une durée de vie de 30 jours
 */
function setCookie(name: string, value: string, days: number): void {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
}

/**
 * Récupère la valeur d'un cookie
 */
function getCookie(name: string): string | null {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

/**
 * Supprime un cookie
 */
function deleteCookie(name: string): void {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
}

/**
 * Enregistre les données d'affiliation dans un cookie (30 jours)
 */
export function saveAffiliateCookie(data: AffiliateCookieData): void {
  try {
    // console.log supprimé
    
    // Enregistrer l'ID d'affilié
    setCookie(AFFILIATE_COOKIE_NAME, data.affiliateId, COOKIE_DURATION_DAYS);
    
    // Enregistrer le nom de l'affilié si disponible
    if (data.affiliateName) {
      setCookie(AFFILIATE_NAME_COOKIE, data.affiliateName, COOKIE_DURATION_DAYS);
    }
    
    // Enregistrer le code promo si disponible
    if (data.code) {
      setCookie(AFFILIATE_CODE_COOKIE, data.code, COOKIE_DURATION_DAYS);
    }
    
    // console.log supprimé
  } catch (error) {
    // console.error supprimé
  }
}

/**
 * Récupère les données d'affiliation depuis le cookie
 */
export function getAffiliateCookie(): AffiliateCookieData | null {
  try {
    const affiliateId = getCookie(AFFILIATE_COOKIE_NAME);
    
    if (!affiliateId) {
      return null;
    }
    
    const affiliateName = getCookie(AFFILIATE_NAME_COOKIE);
    const code = getCookie(AFFILIATE_CODE_COOKIE);
    
    return {
      affiliateId,
      affiliateName: affiliateName || undefined,
      code: code || undefined
    };
  } catch (error) {
    // console.error supprimé
    return null;
  }
}

/**
 * Supprime les cookies d'affiliation
 */
export function clearAffiliateCookie(): void {
  try {
    deleteCookie(AFFILIATE_COOKIE_NAME);
    deleteCookie(AFFILIATE_NAME_COOKIE);
    deleteCookie(AFFILIATE_CODE_COOKIE);
    // console.log supprimé
  } catch (error) {
    // console.error supprimé
  }
}

/**
 * Vérifie si un cookie d'affiliation existe
 */
export function hasAffiliateCookie(): boolean {
  return getCookie(AFFILIATE_COOKIE_NAME) !== null;
}


